import React, { useEffect, useState } from 'react';
import PageConfig from '@/component/layout/PageConfig.tsx';
import useQueryGetUsers from '@/api/user/getUsers.ts';
import UserDetail from '@/pages/users/UserDetail.tsx';
import { useSearchParams } from 'react-router-dom';
import { isEmptyArray } from '@/util/array.ts';
import { useTranslation } from 'react-i18next';

type IProps = object;

const Users: React.FC<IProps> = () => {
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const [userId, setUserId] = useState(Number(searchParams.get('id')));
    const { data, refetch, isLoading } = useQueryGetUsers();

    const onRefresh = () => {
        setUserId(-1);
        refetch();
    };

    useEffect(() => {
        setSearchParams({ id: userId?.toString() });
    }, [userId]);

    return (
        <>
            <PageConfig showTopNav={true} showFooter={true}>
                {!isLoading && !isEmptyArray(data) && (
                    <div className={'grid grid-cols-[1fr_auto] h-full'}>
                        {/* 사용자 상세 정보 */}
                        <UserDetail className={'overflow-y-auto'} id={userId} onRefresh={onRefresh} />
                    </div>
                )}
                {!isLoading && isEmptyArray(data) && (
                    <div className={'bg-sub_b h-full flex flex-col justify-center items-center'}>
                        <p className={'mt-[13px] text-body'}>{t('users.list.empty')}</p>
                    </div>
                )}
            </PageConfig>
        </>
    );
};

export default Users;
